import React, { forwardRef } from 'react';
import classnames from 'classnames';
import ListContext from './ListContext';
import styles from './ListStyles.module.css';
import './SerializedStyles.css';

interface ListWithRefProps {
  type: 'ol' | 'ul' | 'checklist' | 'dl';
  attributes: Record<string, unknown>;
  children: React.ReactNode;
}

const List = forwardRef<HTMLElement | null, any>(function listWithRef(
  { type, children, attributes }: ListWithRefProps,
  ref
) {
  let Tag: 'ol' | 'ul' | 'dl';

  switch (type) {
    case 'ol':
      Tag = 'ol';
      break;

    case 'dl':
      Tag = 'dl';
      break;

    default:
      Tag = 'ul';
  }

  const className = classnames({
    [styles.ulChecklist]: type === 'checklist',
  });

  return (
    <Tag className={className} {...attributes}>
      <ListContext.Provider value={type}>{children}</ListContext.Provider>
    </Tag>
  );
});

export default List;
